import React from 'react'
import BookForm from '../Components/BookForm/BookForm'
import Explore from '../Components/Explore/Explore';
import Exploretype from '../Components/ExploreTypre/Exploretype';

const Frontpage = () => {
  return (
   <>
    <BookForm/>
    <Explore/>
    <Exploretype/>
   </>
  )
}

export default Frontpage